import React from "react";
import AnimateLines from "@/components/AnimateLine";
import AdaptiveImage from "@/components/AdaptiveImage";
import NftButton from "@/components/Button";

import { CopyToClipboard } from "react-copy-to-clipboard";
import { AnimateProps } from "../../../types";
import { onShare } from "@/utils";

import copy from "./copy_16px.svg";

import "./index.css";

const cx = require("classnames");

const TIME_OUT = 2;

const Part10: React.FC<AnimateProps> = (props) => {
  const { data } = props;
  const value = localStorage.getItem(data.user.address);

  const [loading, setLoading] = React.useState<boolean>(false);
  const [num, setNum] = React.useState<number>(TIME_OUT);
  const [code, setCode] = React.useState<string>(
    value ? JSON.parse(value) : ""
  );
  const [share, setShare] = React.useState<boolean>(false);
  const [copied, setCopied] = React.useState<boolean>(false);

  let _timer: string | number | NodeJS.Timeout | null | undefined = null;

  const handelOnShare = () => {
    if (loading) return;

    onShare(data.user.address);
    setShare(false);

    if (value) {
      countDown(num);
      return setLoading(true);
    }

    setLoading(true);

    fetch("/api/annual_invite_code")
      .then((response) => {
        const { status, statusText } = response;

        if (status >= 200 && status < 400) {
          return response.json();
        }

        return Promise.reject({
          code: "STATUS ERROR",
          status,
          statusText,
        });
      })
      .then((res) => {
        if (res.code === 0 && res.msg === "success") {
          setCode(res.data.invite_code);
          localStorage.setItem(
            data.user.address,
            JSON.stringify(res.data.invite_code)
          );
          countDown(TIME_OUT);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const countDown = (num: number) => {
    if (num === 0) {
      setLoading(false);
      setShare(true);
      setNum(TIME_OUT);
      if (_timer) {
        clearTimeout(_timer);
      }
      return (_timer = null);
    }

    _timer = setTimeout(() => {
      setNum(num - 1);
      countDown(num - 1);
    }, 1000);
  };

  const onCopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <div className="part_contain part_contain_10">
      <div style={{ flex: 1, width: "100%" }} />
      <AnimateLines animateType={props.type} animateName="animate__fadeIn">
        <div>
          <AdaptiveImage name="Frame101035" />
        </div>
      </AnimateLines>
      <div style={{ flex: 1, width: "100%" }} />
      <div className="part_content">
        <AnimateLines animateType={props.type}>
          <p className="text_num">
            {share ? "🎉 Thanks for your" : "Share this page on Twitter,"}
          </p>
          <p className="text_num">
            {share ? " promotion, you earned" : "Earn Invitation Code of"}
          </p>
          <p className="text_num">
            {share ? "one invitation link below" : "NFTTrack."}
          </p>
        </AnimateLines>
      </div>
      {share && (
        <input
          readOnly
          className="code"
          value={`https://app.nfttrack.ai/invite/${code}`}
        />
      )}
      <span
        className={cx(
          "copied",
          "animate__animated",
          { animate__fadeIn: copied },
          { copied_hidden: !copied }
        )}
      >
        ✔️Copied
      </span>
      {share ? (
        <CopyToClipboard
          onCopy={onCopy}
          text={`https://app.nfttrack.ai/invite/${code}`}
        >
          <NftButton className="share_bnt" type="primary">
            <img src={copy} alt="" />
            <span>Copy</span>
          </NftButton>
        </CopyToClipboard>
      ) : (
        <NftButton
          onClick={() => handelOnShare()}
          className="share_bnt"
          type="primary"
        >
          {loading ? `Loading...(${num})` : "🎁 Share and Earn"}
        </NftButton>
      )}
      <div style={{ flex: 2, width: "100%" }} />
    </div>
  );
};

export default Part10;
